import { FC, lazy } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useShopPageQueryOptions } from 'src/hooks/useShopQuery';
import { PgPaymentMethod } from 'src/types/Payments';
const AdyenPaymentMethod = lazy(() => import('./Adyen'));
const StripePaymentMethod = lazy(() => import('./Stripe'));
const TossPaymentMethod = lazy(() => import('./Toss'));
const Payments: FC = () => {
  const {
    data: {
      pgPaymentMethod
    }
  } = useSuspenseQuery(useShopPageQueryOptions());
  switch (pgPaymentMethod) {
    case PgPaymentMethod.ADYEN:
      return <AdyenPaymentMethod />;
    case PgPaymentMethod.TOSS:
      return <TossPaymentMethod />;
    case PgPaymentMethod.STRIPE:
      return <StripePaymentMethod />;
    default:
      return null;
  }
};
export default Payments;